import { SagaIterator } from 'redux-saga';
import { PROJECT_NEW_CREATE } from 'src/modules/project-new/actions/ProjectNewActions';
import { projectNewCreateSaga } from 'src/modules/project-new/sagas/projectNewCreateSaga';
import { takeLatest } from 'typed-redux-saga';

export function* projectNewSaga(): SagaIterator<void> {
  yield* takeLatest(PROJECT_NEW_CREATE.isRequest, projectNewCreateSaga);
}
